import './EngagementTables.scss';
import React from 'react';
import PushEngagementTable from './PushEngagementTable';
import RulesEngagementTable from './RulesEngagementTable';
import ContentEngagementTable from './ContentEngagementTable';
import { useFeatureFlags } from 'feature-flags';
import { MAIN_CLASS } from '../constants';
import JourneyEngagementTable from 'pages/Analytics/Overview/Engagement/JourneyEngagementTable';
import SMSEngagementTable from './SMSEngagementTable';
import EmailEngagementTable from './EmailEngagementTable';

const EngagementTables: React.FC = () => {
  const flags = useFeatureFlags(['tx_analytics_sms_table', 'tx_analytics_email_table']);

  const showSMSEngagementTable = flags['tx_analytics_sms_table'];
  const showEmailEngagementTable = flags['tx_analytics_email_table'];

  return (
    <div className={MAIN_CLASS}>
      <JourneyEngagementTable />
      <PushEngagementTable />
      <RulesEngagementTable />
      <ContentEngagementTable />
      {showSMSEngagementTable && <SMSEngagementTable />}
      {showEmailEngagementTable && <EmailEngagementTable />}
    </div>
  );
};

export default EngagementTables;
